module.exports = __webpack_public_path__ + "img/content2.b710a9e8.png";